import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable, of } from 'rxjs';
import { CreateMessageDTO, MessageDTO } from '../models/message.model';

@Injectable({ providedIn: 'root' })
export class MessageService {
  PATH = 'api/message';

  constructor(private http: HttpClient) { }

  getMessages(): Observable<MessageDTO[]> {
    return this.http.get<MessageDTO[]>(`${this.PATH}/list`).pipe(
      map(messages =>
        messages.sort(
          (a, b) =>
            new Date(b.sentTime).getTime() - new Date(a.sentTime).getTime()
        )
      )
    );
  }

  sendMessage(message: CreateMessageDTO): Observable<boolean> {
    return this.http.post<boolean>(`${this.PATH}`, message);
  }
}
